import { makeAutoObservable, runInAction } from 'mobx';

import RootStore from '../Root.store';
import { AuthenticationResponse } from 'data/schemas/auth';
import { getMasterEmployee } from 'data/repositories/auth/authentication.repository';

class AuthenticationStore {
    private _masterEmployeeResponse: AuthenticationResponse | null = null;
    private _masterEmployeeList: AuthenticationResponse[] | null = null;
    private _citizenId: string | undefined = undefined;

    public get masterEmployeeResponse() {
        return this._masterEmployeeResponse;
    }

    public get getCitizen() {
        return this._citizenId;
    }

    public get masterEmployeeList() {
        return this._masterEmployeeList;
    }

    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    public async fetchMasterEmployee(citizenId: string) {
        try {
            const masterEmployeeResponse = await getMasterEmployee({ citizenId });
            runInAction(() => {
                console.log(citizenId);
                console.log(masterEmployeeResponse);

                this._masterEmployeeResponse =
                    masterEmployeeResponse.find(c => (c.ctizenID = citizenId)) ?? null;
                this._citizenId = masterEmployeeResponse.find(
                    c => (c.ctizenID = citizenId)
                )?.ctizenID;
                this._masterEmployeeList = masterEmployeeResponse;
            });
        } catch (error) {
            throw error;
        }
    }
}

export default AuthenticationStore;
